import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import React, { useState } from "react";
import { useMutation } from "@apollo/client";
//import { LOGIN, FIND_USER } from "../queries";
import { TextField, Button, Select, MenuItem, Checkbox, FormControl } from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
//import { Link } from "@mui/material";
//import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CREATE_USER, SEND_EMAIL } from "../queries";
import bcrypt from "bcryptjs";

//const bcryptjs = require("bcryptjs");
//import { useParams } from "react-router-dom";
// Material Kit 2 React examples
//import DefaultFooter from "examples/Footers/DefaultFooter";
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
//import routes from "routes";
//import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/strategia.jpg";
//import { set } from "lodash";
import kunnat from "kunnat";
/* eslint-disable react/prop-types */
const UserRegistration = ({ setError }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  const [t] = useTranslation("common");
  const [email, setEmail] = useState("");
  ////console.log(setEmail);
  const [password, setPassword] = useState("");
  // eslint-disable-next-line
  const [token, setTokeni] = useState("");
  const [verified, setVerified] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  // eslint-disable-next-line
  const [executing, setExecuting] = useState(false);
  ////console.log(setExecuting);
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [postnumber, setPostnumber] = useState("");
  const [postoffice, setPostoffice] = useState("");
  const [phone, setPhone] = useState("");
  const [repassword, setRepassword] = useState("");
  const [activated, setActivated] = useState(false);
  const [datetime, setDatetime] = useState("");
  const [type, setType] = useState("");
  const [role, setRole] = useState("");
  const [gender, setGender] = useState("");
  const [born, setBorn] = useState("");
  // eslint-disable-next-line
  const [municipality, setMunicipality] = useState("");
  const [secondarymunicipality, setSecondarymunicipality] = useState("");
  const [secondarypostnumber, setSecondarypostnumber] = useState("");
  const [secondaryaddress, setSecondaryaddress] = useState("");
  const [secondaryrole, setSecondaryrole] = useState("");
  ////console.log(municipality);
  // eslint-disable-next-line
  const [country, setCountry] = useState("Suomi ");
  ////console.log(setCountry);
  const [accepted, setAccepted] = useState(false);
  //const [acceptedtermsofuse, setAcceptedtermsofuse] = useState(" ");
  //const [loaded, setLoaded] = useState(false);
  //const [rendered, setRendered] = useState(false);
  //const [invisible, setInvisible] = useState(false);
  // eslint-disable-next-line
  const [emailerror, setEmailerror] = useState(false);
  ////console.log(emailerror);
  //const [codea, setCodea] = useState(" ");
  const [code, setCode] = useState("344354");
  ////console.log(setCode);
  //const bcryptjs = require("bcryptjs ")
  //const history = useHistory()
  //const bcryptjs = require("bcryptjs")
  const [addUser] = useMutation(CREATE_USER, {
    onError: (error) => {
      ////console.log("virhe käyttäjän luonnissa: " + error);
      //setError(error.graphQLErrors[0].message)
      setError(error);
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }*/
  });
  const [sendEmail] = useMutation(SEND_EMAIL, {
    // eslint-disable-next-line
    onError: (error) => {
      ////console.log("virhe meilin lähetyksessä: " + error);
      //setError(error.graphQLErrors[0].message)
      setEmailerror(true);
      //setError(error)
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }*/
  });
  /*const getActivation = useQuery(GET_ACTIVATIONCODE, {
    variables: { email },
  });
  */
  /* useEffect(() => {
    const token = getActivation;
    if (token.data !== undefined) {
      ////console.log(token.data.getActivationcode.message);
      setCodea(token.data.getActivationcode.message);
    }
    //.previousData.getActivationcode.message
  }, [email, getActivation]);
  */
  // eslint-disable-next-line
  let userss= " ";
  //userss = useParams().id;
  const uusi = async (event) => {
    ////console.log(event);
    const aika = Date.now();
    const pvm = new Date(aika);
    setDatetime(pvm.toString());
    setEmail(event);
    //setUser(sectionss)
  };

  function getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }
  const submit = async (event) => {
    event.preventDefault();
    if (password === repassword && accepted) {
      //const saltRounds = 17
      const aika = Date.now();
      const pvm = new Date(aika);
      setDatetime(pvm.toString());
      setAccepted(pvm.toString());
      var salt = bcrypt.genSaltSync(12);
      const passwordhash = await bcrypt.hash(password, salt);
      ////console.log(passwordhash);
      let cod = "";
      for (let i = 0; i < 6; i++) {
        let k = getRandomInt(10);
        cod = cod + k;
      }
      ////console.log(cod);
      setCode(cod);
      /* const user = new User({
        username: body.username,
        name: body.name,
        passwordHash,
      })
    
      const savedUser = await user.save()
    
      response.json(savedUser)
      */
      //const passwordhash = password
      //const getCode = async () => {
      //    return get
      //}
      addUser({
        variables: {
          name,
          email,
          passwordhash,
          address,
          gender,
          country,
          municipality: postoffice,
          secondarymunicipality,
          secondaryaddress,
          secondarypostnumber,
          secondaryrole,
          born,
          postnumber,
          postoffice,
          datetime,
          phone,
          activated,
          type,
          role,
          code,
          acceptedtermsofuse: datetime,
        },
      });
      sendEmail({
        variables: {
          to: email,
          header: "Kunta.live rekisteröityminen / registration / registrering ",
          text:
            "Aktivoi tunnuksesi osoitteessa / Activate your account in / Aktivera ditt konto genom att / https://kunta.live/activateuser" +
            " Koodi / Code / Koda: " +
            code,
        },
        // "Kiitos rekisteröitymisestä / Thank you for registering / Tack för din registrering "
      });
      ////console.log("MEILATTU ");
      //sectionid: sectionid.length > 0 ? sectionid :  "tyhjä "
      setDatetime("");
      setName("");
      setEmail("");
      setPassword("");
      setAddress("");
      setPostnumber("");
      setPostoffice("");
      setPhone("");
      setRepassword("");
      setType("");
      setRole("");
      setActivated("");
      setBorn("");
      setGender("");
      setMunicipality("");
      setSecondarymunicipality("");
      setSubmitted(true);
      setSecondarymunicipality("");
      setSecondaryaddress("");
      setSecondarypostnumber("");
      setSecondaryrole("");
      //setSectionid(sectionss)
    } else {
      alert(t("common.passwordmismatch"));
    }
  };
  /*const stylea = {
    background:  "white ",
    opacity: 0.9
  };*/
  function onChange(value) {
    ////console.log("Captcha value:", value);
    setTokeni(value);
    ////console.log(token);
    setVerified(!verified);
  }
  if (submitted) {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 500px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "left",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="h1"
                color="dark"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                {t("headers.registration")}
              </MKTypography>
              <MKTypography
                variant="body1"
                color="dark"
                textAlign="left"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                {t("common.registrationok")}
                <br />
                <br />
                <a href="/">{t("common.tostart")}</a>
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  } else {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 500px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "left",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="h1"
                color="dark"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                <h2>{t("headers.registration")}</h2>
              </MKTypography>
              <MKTypography
                variant="body1"
                color="dark"
                textAlign="left"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                <form onSubmit={submit}>
                  <tr>
                    <td>{t("common.name")}</td>
                    <td>
                      <TextField value={name} onChange={({ target }) => setName(target.value)} />
                    </td>
                  </tr>
                  <tr>
                    <td>{t("common.email")}</td>
                    <td>
                      <TextField value={email} onChange={({ target }) => uusi(target.value)} />
                    </td>
                  </tr>
                  <tr>
                    <td>{t("common.password")}</td>
                    <td>
                      <TextField
                        type="password"
                        value={password}
                        onChange={({ target }) => setPassword(target.value)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>{t("common.repassword")}</td>
                    <td>
                      <TextField
                        type="password"
                        value={repassword}
                        onChange={({ target }) => setRepassword(target.value)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>{t("common.address")}</td>
                    <td>
                      <TextField
                        value={address}
                        onChange={({ target }) => setAddress(target.value)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>{t("common.postnumber")}</td>
                    <td>
                      <TextField
                        value={postnumber}
                        onChange={({ target }) => setPostnumber(target.value)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>{t("common.postoffice")}</td>
                    <td>
                      <FormControl style={{ minWidth: 220 }}>
                        <Select
                          labelId="postoffice"
                          id="postoffice"
                          value={postoffice}
                          onChange={({ target }) => setPostoffice(target.value)}
                        >
                          <MenuItem value={""}>ei valittu</MenuItem>
                          {kunnat.map((k) => (
                            <MenuItem key={k.name} value={k.name}>
                              {k.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </td>
                  </tr>
                  <tr>
                    <td>{t("common.role")}</td>
                    <td>
                      <FormControl style={{ minWidth: 220 }}>
                        <Select
                          labelId="role"
                          id="role"
                          value={role}
                          onChange={({ target }) => setRole(target.value)}
                        >
                          <MenuItem value={""}>ei valittu</MenuItem>
                          <MenuItem value={"kuntalainen"}>kuntalainen</MenuItem>
                          <MenuItem value={"mökkiläinen"}>mökkiläinen</MenuItem>
                          <MenuItem value={"yrittäjä"}>yritys kunnassa</MenuItem>
                          <MenuItem value={"ulkokuntalainen"}>ulkokuntalainen</MenuItem>
                        </Select>
                      </FormControl>
                    </td>
                  </tr>
                  <tr>
                    <td>{t("user.secondaryaddress")}</td>
                    <td>
                      <TextField
                        value={secondaryaddress}
                        onChange={({ target }) => setSecondaryaddress(target.value)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>{t("user.secondarypostnumber")}</td>
                    <td>
                      <TextField
                        value={secondarypostnumber}
                        onChange={({ target }) => setSecondarypostnumber(target.value)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>{t("common.secondarymunicipality")}</td>
                    <td>
                      <FormControl style={{ minWidth: 220 }}>
                        <Select
                          labelId="secondarymunicipality"
                          id="secondarymunicipality"
                          value={secondarymunicipality}
                          onChange={({ target }) => setSecondarymunicipality(target.value)}
                        >
                          <MenuItem value={""}>ei valittu</MenuItem>
                          {kunnat.map((k) => (
                            <MenuItem key={k.name} value={k.name}>
                              {k.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </td>
                  </tr>
                  <tr>
                    <td>{t("user.secondaryrole")}</td>
                    <td>
                      <FormControl style={{ minWidth: 220 }}>
                        <Select
                          labelId="role"
                          id="role"
                          value={secondaryrole}
                          onChange={({ target }) => setSecondaryrole(target.value)}
                        >
                          <MenuItem value={""}>ei valittu</MenuItem>
                          <MenuItem value={"kuntalainen"}>kuntalainen</MenuItem>
                          <MenuItem value={"mökkiläinen"}>mökkiläinen</MenuItem>
                          <MenuItem value={"yrittäjä"}>yritys kunnassa</MenuItem>
                          <MenuItem value={"ulkokuntalainen"}>ulkokuntalainen</MenuItem>
                        </Select>
                      </FormControl>
                    </td>
                  </tr>
                  <tr>
                    <td>{t("common.born")}</td>
                    <td>
                      <FormControl style={{ minWidth: 220 }}>
                        <Select
                          labelId="born"
                          id="born"
                          value={born}
                          onChange={({ target }) => setBorn(target.value)}
                        >
                          <MenuItem value={""}>ei valittu</MenuItem>
                          <MenuItem value={"2023"}>2023</MenuItem>
                          <MenuItem value={"2022"}>2022</MenuItem>
                          <MenuItem value={"2021"}>2021</MenuItem>
                          <MenuItem value={"2020"}>2020</MenuItem>
                          <MenuItem value={"2019"}>2019</MenuItem>
                          <MenuItem value={"2018"}>2018</MenuItem>
                          <MenuItem value={"2017"}>2017</MenuItem>
                          <MenuItem value={"2016"}>2016</MenuItem>
                          <MenuItem value={"2015"}>2015</MenuItem>
                          <MenuItem value={"2014"}>2014</MenuItem>
                          <MenuItem value={"2013"}>2013</MenuItem>
                          <MenuItem value={"2012"}>2012</MenuItem>
                          <MenuItem value={"2011"}>2011</MenuItem>
                          <MenuItem value={"2010"}>2010</MenuItem>
                          <MenuItem value={"2009"}>2009</MenuItem>
                          <MenuItem value={"2008"}>2008</MenuItem>
                          <MenuItem value={"2007"}>2007</MenuItem>
                          <MenuItem value={"2006"}>2006</MenuItem>
                          <MenuItem value={"2005"}>2005</MenuItem>
                          <MenuItem value={"2004"}>2004</MenuItem>
                          <MenuItem value={"2003"}>2003</MenuItem>
                          <MenuItem value={"2002"}>2002</MenuItem>
                          <MenuItem value={"2001"}>2001</MenuItem>
                          <MenuItem value={"2000"}>2000</MenuItem>
                          <MenuItem value={"1999"}>1999</MenuItem>
                          <MenuItem value={"1998"}>1998</MenuItem>
                          <MenuItem value={"1997"}>1997</MenuItem>
                          <MenuItem value={"1996"}>1996</MenuItem>
                          <MenuItem value={"1995"}>1995</MenuItem>
                          <MenuItem value={"1994"}>1994</MenuItem>
                          <MenuItem value={"1993"}>1993</MenuItem>
                          <MenuItem value={"1992"}>1992</MenuItem>
                          <MenuItem value={"1991"}>1991</MenuItem>
                          <MenuItem value={"1990"}>1990</MenuItem>
                          <MenuItem value={"1989"}>1989</MenuItem>
                          <MenuItem value={"1988"}>1988</MenuItem>
                          <MenuItem value={"1987"}>1987</MenuItem>
                          <MenuItem value={"1986"}>1986</MenuItem>
                          <MenuItem value={"1985"}>1985</MenuItem>
                          <MenuItem value={"1984"}>1984</MenuItem>
                          <MenuItem value={"1983"}>1983</MenuItem>
                          <MenuItem value={"1982"}>1982</MenuItem>
                          <MenuItem value={"1981"}>1981</MenuItem>
                          <MenuItem value={"1980"}>1980</MenuItem>
                          <MenuItem value={"1979"}>1979</MenuItem>
                          <MenuItem value={"1978"}>1978</MenuItem>
                          <MenuItem value={"1977"}>1977</MenuItem>
                          <MenuItem value={"1976"}>1976</MenuItem>
                          <MenuItem value={"1975"}>1975</MenuItem>
                          <MenuItem value={"1974"}>1974</MenuItem>
                          <MenuItem value={"1973"}>1973</MenuItem>
                          <MenuItem value={"1972"}>1972</MenuItem>
                          <MenuItem value={"1971"}>1971</MenuItem>
                          <MenuItem value={"1970"}>1970</MenuItem>
                          <MenuItem value={"1969"}>1969</MenuItem>
                          <MenuItem value={"1968"}>1968</MenuItem>
                          <MenuItem value={"1967"}>1967</MenuItem>
                          <MenuItem value={"1966"}>1966</MenuItem>
                          <MenuItem value={"1965"}>1965</MenuItem>
                          <MenuItem value={"1964"}>1964</MenuItem>
                          <MenuItem value={"1963"}>1963</MenuItem>
                          <MenuItem value={"1962"}>1962</MenuItem>
                          <MenuItem value={"1961"}>1961</MenuItem>
                          <MenuItem value={"1960"}>1960</MenuItem>
                          <MenuItem value={"1959"}>1959</MenuItem>
                          <MenuItem value={"1958"}>1958</MenuItem>
                          <MenuItem value={"1957"}>1957</MenuItem>
                          <MenuItem value={"1956"}>1956</MenuItem>
                          <MenuItem value={"1955"}>1955</MenuItem>
                          <MenuItem value={"1954"}>1954</MenuItem>
                          <MenuItem value={"1953"}>1953</MenuItem>
                          <MenuItem value={"1952"}>1952</MenuItem>
                          <MenuItem value={"1951"}>1951</MenuItem>
                          <MenuItem value={"1950"}>1950</MenuItem>
                          <MenuItem value={"1949"}>1949</MenuItem>
                          <MenuItem value={"1948"}>1948</MenuItem>
                          <MenuItem value={"1947"}>1947</MenuItem>
                          <MenuItem value={"1946"}>1946</MenuItem>
                          <MenuItem value={"1945"}>1945</MenuItem>
                          <MenuItem value={"1944"}>1944</MenuItem>
                          <MenuItem value={"1943"}>1943</MenuItem>
                          <MenuItem value={"1942"}>1942</MenuItem>
                          <MenuItem value={"1941"}>1941</MenuItem>
                          <MenuItem value={"1940"}>1940</MenuItem>
                          <MenuItem value={"1939"}>1939</MenuItem>
                          <MenuItem value={"1938"}>1938</MenuItem>
                          <MenuItem value={"1937"}>1937</MenuItem>
                          <MenuItem value={"1936"}>1936</MenuItem>
                          <MenuItem value={"1935"}>1935</MenuItem>
                          <MenuItem value={"1934"}>1934</MenuItem>
                          <MenuItem value={"1933"}>1933</MenuItem>
                          <MenuItem value={"1932"}>1932</MenuItem>
                          <MenuItem value={"1931"}>1931</MenuItem>
                          <MenuItem value={"1930"}>1930</MenuItem>
                          <MenuItem value={"1929"}>1929</MenuItem>
                          <MenuItem value={"1928"}>1928</MenuItem>
                          <MenuItem value={"1927"}>1927</MenuItem>
                          <MenuItem value={"1926"}>1926</MenuItem>
                          <MenuItem value={"1925"}>1925</MenuItem>
                          <MenuItem value={"1924"}>1924</MenuItem>
                          <MenuItem value={"1923"}>1923</MenuItem>
                          <MenuItem value={"1922"}>1922</MenuItem>
                          <MenuItem value={"1921"}>1921</MenuItem>
                          <MenuItem value={"1920"}>1920</MenuItem>
                          <MenuItem value={"1919"}>1919</MenuItem>
                          <MenuItem value={"1918"}>1918</MenuItem>
                          <MenuItem value={"1917"}>1917</MenuItem>
                          <MenuItem value={"1916"}>1916</MenuItem>
                          <MenuItem value={"1915"}>1915</MenuItem>
                          <MenuItem value={"1914"}>1914</MenuItem>
                          <MenuItem value={"1913"}>1913</MenuItem>
                          <MenuItem value={"1912"}>1912</MenuItem>
                          <MenuItem value={"1911"}>1911</MenuItem>
                          <MenuItem value={"1910"}>1910</MenuItem>
                        </Select>
                      </FormControl>
                    </td>
                  </tr>
                  <tr>
                    <td>{t("common.gender")}</td>
                    <td>
                      <FormControl style={{ minWidth: 220 }}>
                        <Select
                          labelId="gender"
                          id="gender"
                          value={gender}
                          onChange={({ target }) => setGender(target.value)}
                          inputProps={{
                            MenuProps: {
                              MenuListProps: {
                                sx: {
                                  backgroundColor: "white",
                                },
                              },
                            },
                          }}
                        >
                          <MenuItem value={"ei valitt"}>ei valittu</MenuItem>
                          <MenuItem value={"nainen"}>Nainen</MenuItem>
                          <MenuItem value={"mies"}>Mies</MenuItem>
                          <MenuItem value={"muu"}>Muu</MenuItem>
                        </Select>
                      </FormControl>
                    </td>
                  </tr>
                  <tr>
                    <td>{t("common.phone")}</td>
                    <td>
                      <TextField value={phone} onChange={({ target }) => setPhone(target.value)} />
                    </td>
                  </tr>
                  <br />
                  <a href="/termsofuse" target="0">
                    {t("termsofuse.header")}
                  </a>
                  <br />
                  {t("common.acceptterms")}
                  {"  "}
                  <Checkbox
                    style={{ backgroundColor: "grey" }}
                    sx={{
                      "&.Mui-checked": {
                        color: "red",
                      },
                    }}
                    value={accepted}
                    onChange={() => setAccepted(!accepted)}
                  />
                  <br />
                  <br />
                  <div>
                    <ReCAPTCHA
                      sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP"
                      onChange={onChange}
                    />
                  </div>
                  <br />
                  <Button
                    variant="contained"
                    style={{ backgroundColor: "#07575B", color: "#C4DFE6", fontSize: "14px" }}
                    type="submit"
                    disabled={!verified}
                    executing={executing}
                    submitted={submitted}
                  >
                    {submitted ? t("common.done") : executing ? "Verifying" : t("common.send")}
                  </Button>
                  {verified}
                  {executing}
                  {submitted}
                </form>
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  }
};
export default UserRegistration;
